import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  name: '',
  email: '',
  company: '',
  address: '',
  message: '',
  search: '',
  status: 0,
};
export const inquiryItemSlice = createSlice({
  name: 'inquiry',
  initialState,
  reducers: {
    setItem: (state, action) => {
      const { name, value } = action.payload;
      state[name] = value;
    },
    setDefaultValue: (_, action) => {
      if (!action?.payload?.id) return initialState;
      return { ...action.payload };
    },
    resetData: () => {
      return initialState;
    },
  },
});
export const { setItem, setDefaultValue, resetData } = inquiryItemSlice.actions;

export default inquiryItemSlice.reducer;
